module.exports = __webpack_public_path__ + "img/81000.aeb40fcc.jpg";